<div class="page-wrapper">
  <div class="header-section-wrapper">
    <!-- Navbar -->
    <div class="top-nav">
      <div class="logo">
        <img
          src="assets/images/beExpert-logo-new.png"
          alt="BeExpert Logo"
          class="brand-logo-img"
        />
        <span class="brand-text">BeExpert</span>
      </div>
    </div>

    <!-- Header Text -->
    <div class="header-section-content">
      <h1 class="page-title">Complete your company profile</h1>
      <p class="page-subtitle">
        Hi there, your signup details are pre-filled below. Add your logo and
        remaining info to finish onboarding.
      </p>
    </div>
  </div>

  <div class="enrollment-container">
    <form
      [formGroup]="companyForm"
      (ngSubmit)="onSubmit()"
      class="enrollment-form"
    >
      <!-- Company Logo Section -->
      <div class="form-card">
        <h2 class="card-title">Company Logo</h2>

        <div class="upload-area" (click)="logoInput.click()">
          <input
            #logoInput
            type="file"
            accept=".png,.jpg,.jpeg,.svg"
            hidden
            (change)="onLogoSelect($event)"
          />

          <!-- Preview -->
          <!-- Preview -->
          <div
            class="logo-preview-wrapper"
            *ngIf="logoPreview"
            (click)="$event.stopPropagation()"
          >
            <img
              [src]="logoPreview"
              alt="Company Logo"
              class="company-logo-preview"
            />

            <div class="logo-file-details">
              <p class="logo-file-name">
                {{ selectedLogoFile?.name }}
              </p>

              <p class="logo-file-size">
                {{ (selectedLogoFile?.size || 0) / 1024 | number: "1.0-0" }} KB
              </p>
            </div>

            <button
              type="button"
              class="remove-logo-btn"
              (click)="removeLogo($event)"
            >
              ×
            </button>
          </div>

          <!-- Upload UI -->
          <ng-container *ngIf="!logoPreview">
            <div class="upload-icon-wrapper">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="upload-icon"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                <polyline points="17 8 12 3 7 8"></polyline>
                <line x1="12" y1="3" x2="12" y2="15"></line>
              </svg>
            </div>

            <div class="upload-text-wrapper">
              <p class="upload-primary-text">Click to upload your logo</p>

              <p class="upload-secondary-text">PNG, JPG or SVG up to 2MB</p>
            </div>
          </ng-container>
        </div>
      </div>

      <!-- Company Details Section -->
      <div class="form-card">
        <h2 class="card-title">Company Details</h2>
        <div class="form-grid">
          <div class="form-group">
            <label class="form-label">
              Company Name <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="company_name"
              placeholder="BeExpert"
            />
            <span class="help-text">From signup</span>
          </div>

          <div class="form-group">
            <label class="form-label">
              Industry <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <select
              class="form-select disabled-input"
              formControlName="industry"
              readonly
            >
              <option value="" disabled selected>Select industry</option>
              <option value="Information Technology">
                Information Technology
              </option>
              <option value="Education / EdTech">Education / EdTech</option>
              <option value="Healthcare & MedTech">Healthcare & MedTech</option>
              <option value="FinTech & Banking">FinTech & Banking</option>
              <option value="Retail & E-commerce">Retail & E-commerce</option>
              <option value="Recruitment & HRTech">Recruitment & HRTech</option>
              <option value="Real Estate & PropTech">
                Real Estate & PropTech
              </option>
              <option value="Logistics & Supply Chain">
                Logistics & Supply Chain
              </option>
              <option value="Travel & Hospitality">Travel & Hospitality</option>
              <option value="Manufacturing">Manufacturing</option>
              <option value="Automotive">Automotive</option>
              <option value="Media & Entertainment">
                Media & Entertainment
              </option>
              <option value="Food & Restaurant Industry">
                Food & Restaurant Industry
              </option>
              <option value="Fitness & Wellness">Fitness & Wellness</option>
              <option value="Insurance">Insurance</option>
              <option value="LegalTech">LegalTech</option>
              <option value="SaaS & Software Products">
                SaaS & Software Products
              </option>
              <option
                *ngIf="isCustomIndustry()"
                [value]="companyForm.get('industry')?.value"
              >
                {{ companyForm.get("industry")?.value }}
              </option>
            </select>
            <span class="help-text">From signup</span>
          </div>

          <div class="form-group">
            <label class="form-label">
              Company URL <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="company_url"
              placeholder="beexpert.com"
            />
            <span class="help-text">From signup</span>
          </div>

          <div
            class="form-group"
            [class.has-error]="
              companyForm.get('linkedin_profile')?.touched &&
              companyForm.get('linkedin_profile')?.invalid
            "
          >
            <label class="form-label">LinkedIn Profile</label>
            <input
              type="text"
              class="form-input"
              formControlName="linkedin_profile"
              placeholder="https://linkedin.com/company/..."
            />
            <div
              class="error-message"
              *ngIf="
                companyForm.get('linkedin_profile')?.touched &&
                companyForm.get('linkedin_profile')?.invalid
              "
            >
              <span
                *ngIf="companyForm.get('linkedin_profile')?.errors?.['pattern']"
                >Enter a valid LinkedIn Profile URL.</span
              >
            </div>
          </div>

          <div
            class="form-group full-width"
            [class.has-error]="
              companyForm.get('about_company')?.touched &&
              companyForm.get('about_company')?.invalid
            "
          >
            <label class="form-label"
              >About Company <span class="required-star">*</span></label
            >
            <div class="textarea-wrapper">
              <textarea
                class="form-textarea"
                formControlName="about_company"
                placeholder="Brief description of your company..."
              ></textarea>
              <div class="edit-icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M12 20h9"></path>
                  <path
                    d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
                  ></path>
                </svg>
              </div>
            </div>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('about_company')?.touched &&
                companyForm.get('about_company')?.invalid
              "
            >
              <span
                *ngIf="companyForm.get('about_company')?.errors?.['required']"
                >About Company is required.</span
              >
              <span
                *ngIf="
                  companyForm.get('about_company')?.errors?.['minlength'] ||
                  companyForm.get('about_company')?.errors?.['maxlength']
                "
                >About Company must be between 10 and 1000 characters.</span
              >
              <span
                *ngIf="
                  companyForm.get('about_company')?.errors?.['pattern'] &&
                  !companyForm.get('about_company')?.errors?.['minlength'] &&
                  !companyForm.get('about_company')?.errors?.['maxlength']
                "
                >About Company contains invalid characters.</span
              >
            </div>
          </div>

          <div
            class="form-group full-width"
            [class.has-error]="
              companyForm.get('office_locations')?.touched &&
              companyForm.get('office_locations')?.invalid
            "
          >
            <label class="form-label"
              >Office Locations <span class="required-star">*</span></label
            >

            <!-- Input + Button -->
            <div class="location-add-wrapper">
              <input
                type="text"
                class="form-input"
                formControlName="office_locations"
                placeholder="e.g. Mumbai, India"
                (keydown.enter)="addLocation(); $event.preventDefault()"
                (input)="
                  onLocationInput($event);
                  companyForm.get('office_locations')?.setErrors(null)
                "
                (focus)="onLocationFocus($event)"
                (blur)="onLocationBlur()"
              />
              <div
                class="suggestions-dropdown"
                *ngIf="showLocationsDropdown && filteredLocations.length"
              >
                <div
                  class="suggestion-item"
                  *ngFor="let loc of filteredLocations"
                  (mousedown)="selectLocation(loc)"
                >
                  {{ loc }}
                </div>
              </div>

              <button
                type="button"
                class="btn-location"
                (click)="addLocation()"
              >
                <svg
                  width="14"
                  height="14"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <line x1="12" y1="5" x2="12" y2="19"></line>
                  <line x1="5" y1="12" x2="19" y2="12"></line>
                </svg>
                Add
              </button>
            </div>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('office_locations')?.touched &&
                companyForm.get('office_locations')?.invalid
              "
            >
              <span
                *ngIf="
                  companyForm.get('office_locations')?.errors?.['required']
                "
                >At least one office location is required.</span
              >
              <span
                *ngIf="
                  companyForm.get('office_locations')?.errors?.[
                    'multipleLocations'
                  ]
                "
                >Please add only one location at a time.</span
              >
              <span
                *ngIf="
                  companyForm.get('office_locations')?.errors?.[
                    'invalidLocation'
                  ]
                "
                >Please select a valid location from the suggestions.</span
              >
            </div>
            <div class="location-tags" *ngIf="officeLocations.length">
              <span
                class="location-chip"
                *ngFor="let loc of officeLocations; let i = index"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"
                  ></path>
                  <circle cx="12" cy="10" r="3"></circle>
                </svg>

                {{ loc }}

                <button
                  type="button"
                  class="remove-chip-btn"
                  (click)="removeLocation(i)"
                >
                  ×
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>

      <!-- Point of Contact Section -->
      <div class="form-card">
        <div class="card-header-with-icon">
          <div class="icon-box">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
              <circle cx="12" cy="7" r="4"></circle>
            </svg>
          </div>
          <div class="card-title-group">
            <h2 class="card-title mb-0">Point of Contact</h2>
            <p class="card-subtitle">
              Auto-filled from signup — verify before submitting
            </p>
          </div>
        </div>

        <div class="form-grid">
          <div
            class="form-group"
            [class.has-error]="
              companyForm.get('poc_name')?.touched &&
              companyForm.get('poc_name')?.invalid
            "
          >
            <label class="form-label">
              Name <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="poc_name"
            />
            <span class="help-text">From signup</span>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('poc_name')?.touched &&
                companyForm.get('poc_name')?.invalid
              "
            >
              <span *ngIf="companyForm.get('poc_name')?.errors?.['required']"
                >Point of Contact Name is required.</span
              >
              <span
                *ngIf="
                  companyForm.get('poc_name')?.errors?.['minlength'] ||
                  companyForm.get('poc_name')?.errors?.['maxlength']
                "
                >Enter a valid name.</span
              >
              <span
                *ngIf="
                  companyForm.get('poc_name')?.errors?.['pattern'] &&
                  !companyForm.get('poc_name')?.errors?.['minlength'] &&
                  !companyForm.get('poc_name')?.errors?.['maxlength']
                "
                >Name should contain only alphabets.</span
              >
            </div>
          </div>
          <div
            class="form-group"
            [class.has-error]="
              companyForm.get('poc_email')?.touched &&
              companyForm.get('poc_email')?.invalid
            "
          >
            <label class="form-label">
              Email <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="poc_email"
            />
            <span class="help-text">From signup</span>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('poc_email')?.touched &&
                companyForm.get('poc_email')?.invalid
              "
            >
              <span *ngIf="companyForm.get('poc_email')?.errors?.['required']"
                >Email is required.</span
              >
              <span *ngIf="companyForm.get('poc_email')?.errors?.['email']"
                >Enter a valid email address.</span
              >
            </div>
          </div>
          <div
            class="form-group full-width"
            [class.has-error]="
              companyForm.get('poc_phone')?.touched &&
              companyForm.get('poc_phone')?.invalid
            "
          >
            <label class="form-label">
              Mobile Number <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="poc_phone"
              (input)="onPhoneInput($event, 'poc_phone')"
              (blur)="trimPhoneValue('poc_phone')"
            />
            <span class="help-text">From signup</span>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('poc_phone')?.touched &&
                companyForm.get('poc_phone')?.invalid
              "
            >
              <span *ngIf="companyForm.get('poc_phone')?.errors?.['required']"
                >Phone Number is required.</span
              >
              <span *ngIf="companyForm.get('poc_phone')?.errors?.['onlyDigits']"
                >Phone Number should contain only digits.</span
              >
              <span *ngIf="companyForm.get('poc_phone')?.errors?.['invalidPhone']"
                >Enter a valid Phone Number.</span
              >
            </div>
          </div>
          <div
            class="form-group full-width"
            [class.has-error]="
              companyForm.get('official_email')?.touched &&
              companyForm.get('official_email')?.invalid
            "
          >
            <label class="form-label">
              Official Email <span class="required-star">*</span>
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lock-icon"
                readonly
              >
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
              </svg>
            </label>
            <input
              type="text"
              class="form-input disabled-input"
              formControlName="official_email"
              placeholder="hello@company.com"
            />
            <span class="help-text">From signup</span>
            <div
              class="error-message"
              *ngIf="
                companyForm.get('official_email')?.touched &&
                companyForm.get('official_email')?.invalid
              "
            >
              <span *ngIf="companyForm.get('official_email')?.errors?.['required']"
                >Official Email is required.</span
              >
              <span *ngIf="companyForm.get('official_email')?.errors?.['email']"
                >Enter a valid email address.</span
              >
            </div>
          </div>
        </div>
      </div>

      <!-- HR Contact Section -->
      <div class="form-card">
        <div class="card-header-with-icon">
          <div class="icon-box">
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 18v-6a9 9 0 0 1 18 0v6"></path>
              <path
                d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"
              ></path>
            </svg>
          </div>
          <div class="card-title-group">
            <h2 class="card-title mb-0">HR Contact</h2>
            <p class="card-subtitle">
              Hiring manager / HR representative (optional)
            </p>
          </div>
        </div>

        <div class="form-grid">
          <div class="form-group">
            <label class="form-label">HR Name</label>
            <input
              type="text"
              class="form-input"
              formControlName="hr_name"
              placeholder="Full name"
            />
          </div>
          <div
            class="form-group"
            [class.has-error]="
              companyForm.get('hr_email')?.touched &&
              companyForm.get('hr_email')?.invalid
            "
          >
            <label class="form-label">HR Email</label>
            <input
              type="text"
              class="form-input"
              formControlName="hr_email"
              placeholder="hr@company.com"
            />
            <div
              class="error-message"
              *ngIf="
                companyForm.get('hr_email')?.touched &&
                companyForm.get('hr_email')?.invalid
              "
            >
              <span *ngIf="companyForm.get('hr_email')?.errors?.['email']"
                >Enter a valid email address.</span
              >
            </div>
          </div>
          <div
            class="form-group full-width"
            [class.has-error]="
              companyForm.get('hr_phone')?.touched &&
              companyForm.get('hr_phone')?.invalid
            "
          >
            <label class="form-label">HR Phone Number</label>
            <input
              type="text"
              class="form-input"
              formControlName="hr_phone"
              placeholder="enter phone number"
              (input)="onPhoneInput($event, 'hr_phone')"
              (blur)="trimPhoneValue('hr_phone')"
            />
            <div
              class="error-message"
              *ngIf="
                companyForm.get('hr_phone')?.touched &&
                companyForm.get('hr_phone')?.invalid
              "
            >
              <span *ngIf="companyForm.get('hr_phone')?.errors?.['onlyDigits']"
                >Phone Number should contain only digits.</span
              >
              <span *ngIf="companyForm.get('hr_phone')?.errors?.['invalidPhone']"
                >Please enter a valid number</span
              >
            </div>
          </div>
        </div>
      </div>

      <div class="form-actions">
        <button
          type="button"
          class="btn-submit"
          (click)="onSubmit()"
          [disabled]="companyForm.invalid"
        >
          Review & Submit
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Review Modal -->
<div class="modal-overlay" *ngIf="showReviewModal">
  <div class="modal-container">
    <button class="modal-close" (click)="closeReviewModal()">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="18" y1="6" x2="6" y2="18"></line>
        <line x1="6" y1="6" x2="18" y2="18"></line>
      </svg>
    </button>

    <div class="modal-header">
      <h2 class="modal-title">Review your company profile</h2>
      <p class="modal-subtitle">
        Please review all the details below. Once submitted, your profile will
        be sent for admin approval.
      </p>
    </div>

    <div class="modal-body">
      <div class="review-section">
        <h3 class="section-title">Company Details</h3>
        <div class="review-row">
          <span class="review-label">Company Name</span>
          <span class="review-value">{{
            companyForm.getRawValue().company_name || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Industry</span>
          <span class="review-value">{{
            companyForm.getRawValue().industry || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Company URL</span>
          <span class="review-value">{{
            companyForm.getRawValue().company_url || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">LinkedIn</span>
          <span class="review-value">{{
            companyForm.get("linkedin_profile")?.value || "—"
          }}</span>
        </div>
        <div class="review-row about-review-row">
          <span class="review-label">About</span>
          <span class="review-value">{{
            companyForm.get("about_company")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Office Locations</span>
          <span class="review-value">
            {{ officeLocations.length ? officeLocations.join(", ") : "—" }}
          </span>
        </div>
      </div>

      <div class="review-section">
        <h3 class="section-title">Point of Contact</h3>
        <div class="review-row">
          <span class="review-label">Name</span>
          <span class="review-value">{{
            companyForm.get("poc_name")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Email</span>
          <span class="review-value">{{
            companyForm.get("poc_email")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Mobile</span>
          <span class="review-value">{{
            companyForm.get("poc_phone")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">Official Email</span>
          <span class="review-value">{{
            companyForm.get("official_email")?.value || "—"
          }}</span>
        </div>
      </div>

      <div class="review-section">
        <h3 class="section-title">HR Contact</h3>
        <div class="review-row">
          <span class="review-label">HR Name</span>
          <span class="review-value">{{
            companyForm.get("hr_name")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">HR Email</span>
          <span class="review-value">{{
            companyForm.get("hr_email")?.value || "—"
          }}</span>
        </div>
        <div class="review-row">
          <span class="review-label">HR Phone</span>
          <span class="review-value">{{
            companyForm.get("hr_phone")?.value || "—"
          }}</span>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <div class="footer-actions-right">
        <button class="btn-edit-details" (click)="closeReviewModal()">
          Edit details
        </button>
        <button class="btn-submit-confirm" (click)="onConfirmSubmit()">
          Confirm & Submit
        </button>
      </div>
    </div>
  </div>
</div>
